<ion-content class="my-bets-container">
  <section class="sb-sticky my-bets--header">
    <sports-page-header
      [hasBackButton]="!isMobile"
      [goHome]="true"
      [title]="'Mis Apuestas'"
      class="dark-mode"
    ></sports-page-header>

    <div class="my-bets--filters-wrapper">
      <sb-dropdown-menu
        class="my-bets--dropdown"
        id="filterTypeDropdown"
        [dropdownItems]="filtersType"
        [selectedItem]="selectedFilterType"
        (selectItem)="selectFilterType($event)"
      ></sb-dropdown-menu>
      <sb-dropdown-menu
        class="my-bets--dropdown"
        id="filterDateDropdown"
        [dropdownItems]="filtersDate"
        [selectedItem]="selectedFilterDate"
        (selectItem)="selectFilterDate($event)"
      ></sb-dropdown-menu>
      <ion-button class="my-bets--button btn-icon-only" (click)="getMyBets()"
        ><ion-icon name="search" slot="icon-only"></ion-icon
      ></ion-button>
    </div>
  </section>

  <section class="my-bets--body background-color-dark desktop">
    <ion-list
      class="my-bets--list-content background-color-dark"
      [hidden]="myBetsTickets.length === 0"
      *ngFor="let ticket of myBetsTickets"
      no-lines
    >
      <ion-grid>
        <div class="my-bets--date color-light sticky-item">{{ ticket.TicketsDatetimeNew | sportsExtractDate: [1] }}</div>
        <ion-row>
          <ion-col size="12" size-md="4" size-sm="3" *ngFor="let bet of ticket?.Tickets">
            <my-bets-tile
              [ticket]="bet"
              (goToEvent)="goTsoEvent($event)"
              (getCashoutByTicket)="getCashoutByTicket($event, ticket)"
              (cashout)="payOutTicket($event)"
            >
            </my-bets-tile>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-list>
    <div class="my-bets--empty-state background-color-dark color-grey-400" *ngIf="emptyState">
      {{ emptyStateMessage }}
    </div>
  </section>
  <codere-footer></codere-footer>
</ion-content>
